module.exports = __webpack_public_path__ + "img/bulb.e17ec103.png";